import ReactMarkdown from "react-markdown";
import { Link, useParams } from "react-router-dom";
import pages from "../content/pages.json";
import posts from "../content/posts.json";
import { PostGrid } from "../components/PostGrid";

// A topic page: custom intro content plus every blog post carrying its tag.
// Topic pages are defined in src/content/pages.json (editable in the admin app).
export const Topic = () => {
  const { slug } = useParams();
  const page = pages.find((p) => p.slug === slug);

  if (!page) {
    return (
      <p className="empty-note">
        That page doesn't exist. <Link to="/">Back home</Link>
      </p>
    );
  }

  const tagged = posts.filter((post) => post.tags.includes(page.tag));

  return (
    <>
      <header className="page-header">
        <h1>{page.title}</h1>
        <p className="tagline">{page.tagline}</p>
      </header>
      <div className="prose page-intro">
        <ReactMarkdown>{page.intro}</ReactMarkdown>
      </div>
      {tagged.length > 0 ? (
        <PostGrid posts={tagged} />
      ) : (
        <p className="empty-note">
          No posts here yet - tag a blog post <span className="tag">{page.tag}</span> and
          it will show up automatically.
        </p>
      )}
    </>
  );
};
